export function createLanguages(content) {
  const langs = [];

  const firstKey = Object.keys({ ...content })[0];
  const firstEl = content[firstKey][0];

  for (let key in firstEl) {
    if (key === "element") continue;
    langs.push(key);
  }

  return langs;
}
